export const HONEYPOT_FIELD_NAME = "cc_ref_code";

// Off-screen with an inline style so it doesn't depend on the template's CSS.
// Not display:none or type="hidden", because bots skip those.
const HIDDEN_STYLE = {
  position: "absolute",
  left: "-9999px",
  top: "auto",
  width: "1px",
  height: "1px",
  overflow: "hidden",
};

// Bot trap for email marketing leads: people can't see or tab to it, bots that
// fill every input do. Not part of the form state, so it never reaches the
// order sent to Konnektive.
const HoneypotField = () => (
  <div aria-hidden="true" style={HIDDEN_STYLE}>
    <label htmlFor={HONEYPOT_FIELD_NAME}>Reference code</label>
    <input
      id={HONEYPOT_FIELD_NAME}
      name={HONEYPOT_FIELD_NAME}
      type="text"
      tabIndex={-1}
      autoComplete="off"
      defaultValue=""
    />
  </div>
);

export default HoneypotField;
